import { render, staticRenderFns } from "./case16.vue?vue&type=template&id=04cb4bd3&scoped=true"
import script from "./case16.vue?vue&type=script&lang=js"
export * from "./case16.vue?vue&type=script&lang=js"
import style0 from "./case16.vue?vue&type=style&index=0&id=04cb4bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cb4bd3",
  null
  
)

export default component.exports